import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppConsts } from "../../shared/app-consts";
import { ResetPasswordModel } from "../../shared/ResetPasswordModel";
import { LoginUserRequestModel } from "../../shared/LoginUserRequestModel";
import { LoginUserResponseModel } from "../../shared/LoginUserResponseModel";
import { environment } from "../../../environments/environment";
import { CookieService } from 'ngx-cookie-service';
import { LocalUserDataModel } from '../../shared/models/localUserData.model';
import { BaseService } from "../base.service";
import * as _ from 'lodash'; 
import { Observable } from "rxjs";
import { RecaptchaRequest } from "../../shared/recaptcha-request";
@Injectable()
export class RecaptchaService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  checkRecaptcha(model: RecaptchaRequest): Observable<any> {
    let httpOptions = this.getHttpHeader();
    return this.http.post(environment.API_SERVICE_URL + "Recpatcha/verify", model, httpOptions);
  }

}
